import { type FC } from 'react';

import { Info } from '@livechat/design-system-react-components';

import { NavigationId } from 'constants/navigation';
import { useTextMenuPromoEligibility } from 'hooks/use-text-menu-promo-eligibility';

import { useMoveToTextTooltip } from '../hooks/use-move-to-text-tooltip';

import { NavigationItem } from './navigation-item/NavigationItem';

export const MoveToTextItem: FC = () => {
  const isEligible = useTextMenuPromoEligibility();
  const { isTooltipVisible, dismissTooltip } = useMoveToTextTooltip(isEligible);

  return isEligible ? (
    <NavigationItem
      id={NavigationId.MoveToText}
      tooltip={{
        content: <Info text="Get AI Agent with Text" theme="invert" handleCloseAction={dismissTooltip} />,
        props: {
          kind: 'invert',
          onClose: dismissTooltip,
          isVisible: isTooltipVisible,
          placement: 'right-start',
          offsetMainAxis: 12,
        },
      }}
    />
  ) : null;
};
